export const ACTIVE_ORGANIZATION_ID_HEADER = 'ACTIVE-ORGANIZATION-ID';

export function getActiveOrganizationId(): number {
  return +localStorage.getItem('active_organization_id') || null;
}

export function setActiveOrganizationId(value: number): void {
  localStorage.setItem('active_organization_id', value ? value.toString() : null);
}
